import React from 'react';
import {
  Route,
  Redirect,
  Switch,
  useRouteMatch,
} from 'react-router-dom';
import { compose } from 'recompose';

import useToolsNavigation from '../../hooks/useToolsNavigation';
import { withMealPlanContextProvider } from '../../context/MealPlanContext';
import pages, { pagesConfig } from '../../config/pages';
import CoachToolsRoute from '../ToolsRoute';
import routes from './routes';

const RecipesRoutes = () => {
  const { path } = useRouteMatch();
  const { pathname } = useToolsNavigation();

  return (
    <Switch>
      {routes.map(({
        pageId,
        path: routePath,
        component,
      }) => (
        <CoachToolsRoute
          key={pageId}
          pageId={pageId}
          path={`${path}/${routePath}`}
          component={component}
        />
      ))}

      <Route exact path={`${path}`}>
        <Redirect to={{ pathname: `${pathname}/${pagesConfig[pages.RECIPES].path}` }} />
      </Route>
    </Switch>
  );
};

export default compose(
  withMealPlanContextProvider,
)(RecipesRoutes);
